// Litsenziya2.js
import React, {useEffect, useState} from 'react';
import {
    Container,
    Row,
    Col,
    Form,
    Table,
    Button,
    Spinner,
    Card,
    Pagination, InputGroup, FormControl
} from 'react-bootstrap';
import {FaPlus, FaEdit, FaTrash, FaEye, FaSearch} from 'react-icons/fa';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import TransportService from '../../services/TransportService';
import LitsenziyaService from '../../services/LitsenziyaService';
import FaylService from '../../services/FaylService';
import ConfirmModal from '.././ConfirmModal';
import LitsenziyaAdd from '.././LitsenziyaAdd';
import {parseFormattedNumber} from "../../utils/formatters";

const ShowLitsenziya = ({ transportId }) => {
    const [list, setList] = useState([]);
    const [transportList, setTransportList] = useState([]);
    const [filteredTransports, setFilteredTransports] = useState([]);
    const [formData, setFormData] = useState({
        transportNumber: '',
        transport_id: '',
        raqam: '',
        dan: '',
        gacha: '',
        izoh: '',
        fayl: null,
        narx: '',
        id: ''
    });
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    const [expiryFilter, setExpiryFilter] = useState('0');
    const [showCombo, setShowCombo] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [loading, setLoading] = useState(false);

    const perPageOptions = [5, 10, 20, 50, 100];

    useEffect(() => {
        loadTransports();
    }, []);

    useEffect(() => {
        loadData();
    }, [currentPage, perPage, searchTerm, sortOrder, expiryFilter]);

    const loadTransports = async () => {
        const resp = await TransportService.getTransportList();
        setTransportList(resp.data);
    };

    const loadData = async () => {
        setLoading(true);
        const res = await LitsenziyaService.getLitsenziyaListByFilter(currentPage, perPage, searchTerm, sortOrder, expiryFilter, transportId, 0);
        setList(res.data.data);
        setTotalItems(res.data.total);
        setTotalPages(Math.ceil(res.data.total / perPage));
        setLoading(false);
    };

    const getDayDiff = (gacha) => {
        const now = new Date();
        return Math.ceil((new Date(gacha) - now) / (1000 * 60 * 60 * 24));
    };

    const getColorClass = (days) => {
        const day = days || 0;
        if (day < 0) return 'text-danger fw-bold';
        if (day < 7) return 'text-warning fw-bold';
        return 'text-success fw-bold';
    };

    const handleTransportInput = (e) => {
        const val = e.target.value;
        setFormData({...formData, transportNumber: val});
        setFilteredTransports(
            transportList.filter(t => t.davlat_raqam.toLowerCase().includes(val.toLowerCase()))
        );
        setShowCombo(true);
    };

    const selectTransport = (val, id) => {
        setFormData({...formData, transportNumber: val, transport_id: id});
        setShowCombo(false);
    };

    const handleSave = async () => {
        const isEdit = !!formData.id;
        if (!formData.transport_id || !formData.raqam || !formData.dan || !formData.gacha || !formData.narx) {
            toast.error("Barcha maydonlarni to'ldiring!", {position: "bottom-right"});
            return;
        }
        const amount = parseFormattedNumber(formData.narx);
        const data = new FormData();
        data.append('id', formData.id);
        data.append('transport_id', formData.transport_id);
        data.append('raqam', formData.raqam);
        data.append('dan', formData.dan);
        data.append('gacha', formData.gacha);
        data.append('narx', amount);
        data.append('izoh', formData.izoh || '');
        if (formData.fayl) data.append('fayl', formData.fayl);

        try {
            isEdit
                ? await LitsenziyaService.updateLitsenziya(data, formData.id)
                : await LitsenziyaService.addLitsenziya(data);
            toast.success(`Litsenziya ${isEdit ? "yangilandi" : "qo'shildi"}`, {position: "bottom-right"});
            setShowModal(false);
            loadData();
        } catch {
            toast.error("Xatolik yuz berdi!");
        }
    };

    const handleGetFile = async (item) => {
        if (!item.fayl || item.fayl === 'no_file' || item.fayl === 'undefined') {
            toast.error('Fayl mavjud emas');
            return;
        }
        const path = await FaylService.getFaylPath(item.fayl);
        window.open(path, '_blank');
    };

    const handleDeleteClick = (item) => {
        setItemToDelete(item);
        setShowConfirmModal(true);
    };

    const handleEditClick = (item) => {
        setSelectedItem(item);
        setFormData({
            ...item,
            transportNumber: item.transport.davlat_raqam
        });
        setShowModal(true);
    }

    const confirmDelete = async () => {
        try {
            await LitsenziyaService.deleteLitsenziya(itemToDelete.id);
            toast.success("Litsenziya o‘chirildi", {position: "bottom-right"});
            loadData();
        } catch {
            toast.error("O‘chirishda xatolik yuz berdi");
        } finally {
            setShowConfirmModal(false);
            setItemToDelete(null);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    const handlePerPageChange = (e) => {
        setPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };

    return (
        <Container fluid className="py-4">
            {/*<ToastContainer/>*/}
            <Card>
                {/*<Card.Header className="d-flex justify-content-between align-items-center">*/}
                {/*    <h5 className="mb-0">Litsenziyalar ro'yxati</h5>*/}
                {/*    <Button onClick={() => {*/}
                {/*        setFormData({*/}
                {/*            transportNumber: '',*/}
                {/*            transport_id: '',*/}
                {/*            raqam: '',*/}
                {/*            dan: '',*/}
                {/*            gacha: '',*/}
                {/*            izoh: '',*/}
                {/*            fayl: null,*/}
                {/*            narx: '',*/}
                {/*            id: ''*/}
                {/*        });*/}
                {/*        setSelectedItem(null);*/}
                {/*        setShowModal(true);*/}
                {/*    }}>*/}
                {/*        <FaPlus/> Qo‘shish*/}
                {/*    </Button>*/}
                {/*</Card.Header>*/}
                <Card.Body>
                    <Row className="mb-3">
                        {/*<Col md={4}>*/}
                        {/*    <Form.Control*/}
                        {/*        placeholder="Qidiruv..."*/}
                        {/*        value={searchTerm}*/}
                        {/*        onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }}*/}
                        {/*    />*/}
                        {/*</Col>*/}
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Tartiblash</Form.Label>
                                <Form.Select value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
                                    <option value="asc">Tugash muddati (asc)</option>
                                    <option value="desc">Tugash muddati (desc)</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Muddati</Form.Label>
                                <Form.Select value={expiryFilter} onChange={e => setExpiryFilter(e.target.value)}>
                                    <option value="0">Hammasi</option>
                                    <option value="-1">Muddati o'tganlar</option>
                                    <option value="7">Kam qolganlar (&lt;7 kun)</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Qidiruv</Form.Label>
                                <InputGroup>
                                    <FormControl
                                        placeholder="Qidirish: raqam, mashina, izoh..."
                                        value={searchTerm}
                                        onChange={e => setSearchTerm(e.target.value)}
                                    />
                                    <Button variant="outline-secondary"><FaSearch/></Button>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>


                    <div className="table-responsive">
                        <Table bordered hover striped>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Transport raqam</th>
                                <th>Litsenziya raqam</th>
                                <th>Muddati</th>
                                <th>Kun farqi</th>
                                <th>Narx</th>
                                <th>Izoh</th>
                                <th>Amallar</th>
                            </tr>
                            </thead>
                            <tbody>
                            {loading ? (
                                    <tr>
                                        <td colSpan="7" className="text-center w-100"><Spinner animation="border"/></td>
                                    </tr>)
                                : list.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className="text-center">Ma'lumot topilmadi</td>
                                    </tr>
                                ) : (
                                    list.map((item, i) => {
                                        const days = getDayDiff(item.gacha);
                                        return (
                                            <tr key={item.id}>
                                                <td>{(currentPage - 1) * perPage + i + 1}</td>
                                                <td>{item.transport.davlat_raqam}</td>
                                                <td>{item.raqam}</td>
                                                <td>{item.gacha}</td>
                                                <td className={getColorClass(days)}>{days}</td>
                                                <td>{item.narx}</td>
                                                <td>{item.izoh}</td>
                                                <td>
                                                    <div className="d-flex">
                                                        {/*<Button variant="link" size="sm"*/}
                                                        {/*        className="text-warning p-0 me-2"*/}
                                                        {/*        onClick={() => handleEditClick(item)}><FaEdit/></Button>*/}
                                                        {/*<Button variant="link" size="sm"*/}
                                                        {/*        className="text-danger p-0 me-2"*/}
                                                        {/*        onClick={() => handleDeleteClick(item)}><FaTrash/></Button>*/}
                                                        <Button variant="link" size="md" className="text-primary p-0"
                                                                onClick={() => handleGetFile(item)}><FaEye/></Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="d-flex align-items-center">
                            <span className="me-2">Har sahifada:</span>
                            <Form.Select
                                style={{width: '80px'}}
                                value={perPage}
                                onChange={handlePerPageChange}
                                disabled={loading}
                            >
                                {perPageOptions.map(option => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </Form.Select>
                            <span className="ms-2">
                {loading ? 'Yuklanmoqda...' : `Jami: ${totalItems} ta`}
              </span>
                        </div>
                        {totalPages > 1 && (
                            <Pagination>
                                {[...Array(totalPages)].map((_, i) => (
                                    <Pagination.Item
                                        key={i}
                                        active={currentPage === i + 1}
                                        onClick={() => handlePageChange(i + 1)}
                                    >
                                        {i + 1}
                                    </Pagination.Item>
                                ))}
                            </Pagination>
                        )}
                    </div>
                </Card.Body>
            </Card>

            <LitsenziyaAdd
                showModal={showModal}
                onHide={() => setShowModal(false)}
                setShowModal={setShowModal}
                selectedItem={selectedItem}
                formData={formData}
                setFormData={setFormData}
                handleTransportInput={handleTransportInput}
                selectTransport={selectTransport}
                filteredTransports={filteredTransports}
                handleSave={handleSave}
                showCombo={showCombo}
                setShowCombo={setShowCombo}
            />

            <ConfirmModal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                onConfirm={confirmDelete}
                title="Litsenziyani o‘chirish"
                message={`Rostan ham \"${itemToDelete?.raqam}\" raqamli litsenziyani o‘chirmoqchimisiz?`}
            />
        </Container>
    );
};

export default ShowLitsenziya;
